<template>
  <div class="gc-start-screen gc-bg-primary gc-px-8 gc-py-12">
    <div class="gc-max-w-5xl gc-mx-auto">
      <div
        class="gc-flex gc-flex-col lg:gc-flex-row gc-justify-between gc-items-center"
      >
        <div class="gc-mr-8 gc-mb-8 lg:gc-mb-0 gc-px-4">
          <h3
            class="gc-mb-0 gc-text-white gc-font-bold gc-text-xl lg:gc-text-2xl gc-text-center lg:gc-text-left"
          >
            {{ $t('start.description') }}
          </h3>
        </div>
        <button
          @click="toggleAssistant()"
          class="gc-bg-secondary gc-px-16 gc-py-2 gc-block gc-font-bold gc-text-sm gc-text-white gc-flex gc-items-center gc-justify-center gc-flex-shrink-0 hover:gc-bg-secondary-dark focus:gc-bg-secondary-dark gc-transition-all gc-duration-150 gc-ease-in-out gc-uppercase gc-border-white gc-border-solid gc-border-2"
        >
          <font-awesome-icon :icon="faCompass" class="gc-mr-3 gc-text-2xl" />
          <span>{{
            started ? $t('stopAssistant') : $t('startAssistant')
          }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';
import { faCompass } from '@fortawesome/pro-solid-svg-icons';
import GcImage from '@/components/primitives/GcImage.vue';
import GcButton from '@/components/primitives/GcButton.vue';

export default defineComponent({
  components: {
    GcButton,
    GcImage,
  },
  props: {
    started: {
      default: false,
      type: Boolean,
    },
  },
  setup: (_, { emit }) => {
    const baseUrl = process.env.VUE_APP_BASE_URL;

    const toggleAssistant = () => {
      emit('toggle');
    };

    return {
      baseUrl,
      faCompass,
      toggleAssistant,
    };
  },
});
</script>

<style lang="scss" scoped>
.gc-start-screen {
  position: relative;
  z-index: 800;
}

.gc-start-screen__background-image,
.gc-start-screen__overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1;
}

.gc-start-screen__overlay {
  z-index: 2;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.75);
}

.gc-start-screen__content {
  position: relative;
  z-index: 2000;
}
.gc-start-screen__icon {
  width: 5rem;
  height: 5rem;
  padding: 1rem;
  border-radius: 50%;
  flex-shrink: 0;
  color: white;
}
</style>
